"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const floating_vue_1 = require("floating-vue");
const lucide_vue_next_1 = require("lucide-vue-next");
/* import { RecommendationIcon } from '@biomemakers/bmk_ui_framework';
import RecommendationsActionsPanel from './RecommendationsActionsPanel.vue'; */
let ProjectItem = class ProjectItem extends vue_property_decorator_1.Vue {
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get triggers() {
        if (this.tooltipEnabled)
            return 'hover';
        return '';
    }
    downloadMainDeliverable() {
        this.$emit('downloadMainDeliverable');
    }
    downloadQR() {
        this.$emit('downloadQR');
    }
    async downloadFarmPDF() {
        if (this.projectSelected.project_type == 'farm') {
            const url = `/data/results/farm/pdf/${this.projectSelected.farm_id}`;
            const link = document.createElement('a');
            link.href = url;
            document.body.appendChild(link);
            window.open(url);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectItem.prototype, "projectSelected", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProjectItem.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], ProjectItem.prototype, "tooltipEnabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProjectItem.prototype, "hasActions", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProjectItem.prototype, "hasRecommendationTooltip", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ProjectItem.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectItem.prototype, "currentProjectDelivery", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProjectItem.prototype, "isBiome", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProjectItem.prototype, "loading", void 0);
ProjectItem = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Tag: bmk_ui_framework_1.Tag,
            Dropdown: floating_vue_1.Dropdown,
            /*         RecommendationIcon,
                    RecommendationsActionsPanel, */
            Button: bmk_ui_framework_1.Button,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            Download: lucide_vue_next_1.Download,
            QrCode: lucide_vue_next_1.QrCode,
            Toggle: bmk_ui_framework_1.Toggle,
            Key: lucide_vue_next_1.Key,
            Lock: lucide_vue_next_1.Lock
        },
    })
], ProjectItem);
exports.default = ProjectItem;
